import React, { useState } from "react";
import { Navbar, Nav, Container, Button, Image, Dropdown } from "react-bootstrap";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { FaUserCog, FaSignOutAlt, FaKey } from "react-icons/fa";

const WebNav = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
    window.location.reload();
  };

  return (
    <Navbar expand="lg" fixed={token ? "top" : undefined} style={{ backgroundColor: '#e9f1ff', backdropFilter: 'blur(8px)' }}>
      <Container className="d-flex justify-content-between">
        <Navbar.Brand href="/" className="fw-bold text-primary d-flex align-items-center">
          <Image src="/images/logo.png" height={30} className="me-2" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {!token ? (
            <Nav className="ms-auto align-items-center gap-3">
              {[
                { to: "/", label: "Home", exact: true },
                { to: "/about-us", label: "About us" },
                { to: "/how-it-work", label: "How it work" },
                { to: "/services", label: "Services" },
                { to: "/contact-us", label: "Contact us" }
              ].map(({ to, label, exact }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={exact}
                  className={({ isActive }) =>
                    `nav-link px-2 fw-semibold ${
                      isActive ? 'text-primary border-bottom border-3 border-primary pb-1' : 'text-dark'
                    }`
                  }
                  style={{ textDecoration: 'none' }}
                >
                  {label}
                </NavLink>
              ))}

              <Button variant="outline-primary" as={Link} to="/login" className="px-4 rounded">
                Sign in
              </Button>
              <Button variant="primary" as={Link} to="/register" className="px-4 rounded">
                Get Started
              </Button>
            </Nav>
          ) : (
            <Nav className="ms-auto align-items-center">
              <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)} align="end">
                <Dropdown.Toggle variant="link" id="dropdown-basic" className="border-0">
                  <FaUserCog size={24} className="text-primary" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate("/profile")}>
                    <FaUserCog className="me-2" /> Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/password")}>
                    <FaKey className="me-2" /> Change Password
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <FaSignOutAlt className="me-2" /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default WebNav;
